import * as React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Label from '@mui/material/FormLabel';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../../actions';
import moment from 'moment';
import dayjs from 'dayjs';
import TriggerTable from './triggerTable';

// Styles for the form
const useStyles = makeStyles({
  formContainer: {
    padding: '20px',
  },
  formRow: {
    // display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  inputField: {
    width: '150px',
    border: 'none',
    padding: '1px',
    boxSizing: 'border-box',
    fontSize: '12px',
  },
  addRowButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
});

// Main component
export default function ProcedureAndTriggerForm({ type }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const patientData = useSelector(
    (state) => state.clinicalReducer.currentCycle,
  );

  const dateHandler = (date, name) => {
    if (type === 'fms') {
      dispatch(setPatientData(`currentCycle.fmsData.${name}`, date));
    } else if (type === 'fet') {
      console.log(`currentCyle.fetSheet.${name}`);
      dispatch(setPatientData(`currentCycle.fetSheet.${name}`, date));
    }
  };

  const timeHandler = (time) => {
    dispatch(setPatientData('currentCycle.fmsData.triggerTime', time));
  };
  const handleInputChange = (e, field) => {
    const { value } = e.target;

    if (type === 'fms') {
      dispatch(setPatientData(`currentCycle.fmsData.${field}`, value));
    } else if (type === 'fet') {
      dispatch(setPatientData(`currentCycle.fetSheet.${field}`, value));
    }
  };

  return (
    <Paper className={classes.formContainer}>
      <React.Fragment>
        <Box className={classes.formRow}>
          <div>
            <div>
              {type === 'fms' ? (
                <TriggerTable
                  triggerDate={
                    patientData.fmsData.triggerDate &&
                    patientData.fmsData.triggerDate != ''
                      ? dayjs(patientData.fmsData.triggerDate).format(
                          'YYYY-MM-DD',
                        )
                      : null
                  }
                  triggerTime={patientData.fmsData.triggerTime || ''}
                  handleDateChange={(date) => dateHandler(date, 'triggerDate')}
                  handleTimeChange={timeHandler}
                />
              ) : (
                <>
                  <Label style={{ width: '200px' }}>
                    {type === 'fms' ? 'Trigger:' : 'Embryo Transfer Date:'}
                  </Label>
                  <DateComponent
                    selectedDate={
                      type === 'fms'
                        ? patientData.fmsData.triggerDate
                          ? dayjs(patientData.fmsData.triggerDate)
                          : null
                        : patientData.fetSheet.triggerDate
                          ? dayjs(patientData.fetSheet.triggerDate)
                          : null
                    }
                    handleDateChange={(date) =>
                      dateHandler(date, 'triggerDate')
                    }
                  />
                </>
              )}
            </div>
            {type !== 'fms' ? (
              <div style={{ display: 'flex', gap: '20px' }}>
                <Label style={{ width: '200px' }}>
                  {type === 'fms' ? 'Trigger Time:' : 'Embryo Transfer Time:'}
                </Label>
                <TextField
                  className={classes.inputField}
                  type="time"
                  variant="standard"
                  value={
                    type === 'fms'
                      ? patientData.fmsData.triggerTime
                      : patientData.fetSheet.triggerTime
                  }
                  onChange={(e) => handleInputChange(e, 'triggerTime')}
                  // InputLabelProps={{ shrink: true }}
                />
              </div>
            ) : null}
          </div>
        </Box>
        <Box className={classes.formRow}>
          <div style={{ display: 'flex', gap: '80px' }}>
            <div style={{ display: 'flex', gap: '20px' }}>
              <Label style={{ width: '210px' }}>
                {type === 'fms' ? 'Procedure Date:' : 'Embryo Thawing:'}
              </Label>
              <DateComponent
                selectedDate={
                  type === 'fms'
                    ? patientData.fmsData.procedureDate
                      ? dayjs(patientData.fmsData.procedureDate)
                      : null
                    : patientData.fetSheet.procedureDate
                      ? dayjs(patientData.fetSheet.procedureDate)
                      : null
                }
                handleDateChange={(date) => dateHandler(date, 'procedureDate')}
              />
            </div>
            <div style={{ display: 'flex', gap: '20px' }}>
              <Label style={{ width: '200px' }}>
                {type === 'fms' ? 'Procedure Time:' : 'Embryo Thawing Time:'}
              </Label>
              <TextField
                className={classes.inputField}
                type="time"
                variant="standard"
                value={
                  type === 'fms'
                    ? patientData.fmsData.procedureTime
                    : patientData.fetSheet.procedureTime
                }
                onChange={(e) => handleInputChange(e, 'procedureTime')}
                // InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        </Box>
      </React.Fragment>
    </Paper>
  );
}
